import { MediaDigitalArchiveRequestInterface } from '../../../interfaces/request/media-digital-archive/media-digital-archive-request-interface';
import { MediaDigitalArchiveResponseModel } from '../../response/media-digital-archive/media-digital-archive-response-model';

export class MediaDigitalArchiveRequestModel implements MediaDigitalArchiveRequestInterface {
  Authorization: string = '';
  digitalArchivePresentationImageId?: string;
  digitalArchiveContentId?: string;

  constructor(init?: Partial<MediaDigitalArchiveResponseModel>) {
    Object.assign(this, init);
  }
}
